/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';

/**
 * コンテンツに該当するバナー
 * @export
 * @interface ContentBannerModel
 */
export interface ContentBannerModel {
    /**
     * バナーに付与される一意のID
     * @type {number}
     * @memberof ContentBannerModel
     */
    id: number;
    /**
     * 作品タイトル
     * @type {number}
     * @memberof ContentBannerModel
     */
    contentId?: number;
    /**
     * 
     * @type {ImageModel}
     * @memberof ContentBannerModel
     */
    images?: ImageModel;
    /**
     * バナーのリンク先
     * @type {string}
     * @memberof ContentBannerModel
     */
    url?: string;
    /**
     * バナーのリリース日のUNIX時間
     * @type {number}
     * @memberof ContentBannerModel
     */
    releaseDate?: number;
    /**
     * バナーのリリース終了日のUNIX時間
     * @type {number}
     * @memberof ContentBannerModel
     */
    releaseEndDate?: number;
}

/**
 * Check if a given object implements the ContentBannerModel interface.
 */
export function instanceOfContentBannerModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ContentBannerModelFromJSON(json: any): ContentBannerModel {
    return ContentBannerModelFromJSONTyped(json, false);
}

export function ContentBannerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentBannerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contentId': !exists(json, 'content_id') ? undefined : json['content_id'],
        'images': !exists(json, 'images') ? undefined : ImageModelFromJSON(json['images']),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'releaseDate': !exists(json, 'releaseDate') ? undefined : json['releaseDate'],
        'releaseEndDate': !exists(json, 'releaseEndDate') ? undefined : json['releaseEndDate'],
    };
}

export function ContentBannerModelToJSON(value?: ContentBannerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'content_id': value.contentId,
        'images': ImageModelToJSON(value.images),
        'url': value.url,
        'releaseDate': value.releaseDate,
        'releaseEndDate': value.releaseEndDate,
    };
}

